/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  $('.reviews__grid').slick({
    centerMode: true,
    centerPadding: '90px',
    slidesToShow: 1,
    focusOnSelect: true,
    arrows: true,
    dots: true,
    variableWidth: true,
  });
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

$('button.slider__button--next').click(function(){
    $('.reviews__grid').slick('slickNext');
});

$('button.slider__button--prev').click(function(){
    $('.reviews__grid').slick('slickPrev');
});
